import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "group route-date" }
const _hoisted_2 = { class: "row routes" }
const _hoisted_3 = { class: "row dates" }
const _hoisted_4 = { class: "date-pickers-container" }

import { getDatesPlaceholder, getNextValidDate, getReturnRoutes } from "@/helpers/quickformHelpers";
import useVuelidate from "@vuelidate/core";
import { computed, reactive, ref, watch } from "vue";
import useAvailableDates from "../composables/useAvailableDates";
import { routes } from "../config/routes";
import { AvailableDates } from "../models/AvailableDates";
import { MultiLegDepartureDetails } from "../models/MultiLegForm";
import { VBtn, VDatePicker, VSelect } from "v-ferry-components";
import SvgIcon from "@/components/base/SvgIcon.vue";
import { onClickOutside } from "@vueuse/core";
import { da } from "date-fns/locale";
import { getWeek } from "date-fns";
import { dateObject } from "@/helpers/dateHelpers";

interface Props {
    index: number;
    modelValue: MultiLegDepartureDetails;
    allDepartures: MultiLegDepartureDetails[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteAndDate',
  props: {
    index: {},
    modelValue: {},
    allDepartures: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { getDates } = useAvailableDates();

const props = __props;

const emit = __emit;

const showDates = ref(false);

const initialPage = computed(() => {
    const date = inputValue.value.date ? new Date(inputValue.value.date) : new Date();
    return dateObject(date);
});

const inputValue = computed({
    get(): MultiLegDepartureDetails {
        return props.modelValue;
    },
    set(value: MultiLegDepartureDetails) {
        emit("update:modelValue", value);
    },
});

const state = reactive({
    route: inputValue.value.route,
    date: inputValue.value.date,
});

const rules = {
    route: {
        required: () => {
            return !!inputValue.value.route;
        },
    },
    date: {
        required: () => {
            return !!inputValue.value.date;
        },
    },
};

const v$ = useVuelidate(rules, state);

const availableDates = ref<AvailableDates>();

const routeRef = ref();

const availableRoutes = computed(() => {
    if (props.index === 0) return routes;
    return getReturnRoutes(props.allDepartures[props.index - 1].route);
});

const datesPlaceholder = computed(() => getDatesPlaceholder(inputValue.value.date));

const previousRoute = computed(() => (props.index != 0 ? props.allDepartures[props.index - 1].route : ""));

watch(previousRoute, (current) => {
    if (current) {
        inputValue.value.route = "";
    }
});

const dropdownDate = ref();

onClickOutside(dropdownDate, () => (showDates.value = false));

const onRouteSelect = (route: string) => {
    getDates(route).then((dates) => {
        availableDates.value = dates;

        if (inputValue.value.date && inputValue.value.date !== getNextValidDate(inputValue.value.date, availableDates.value.disabledDates)) {
            inputValue.value.date = undefined;
        }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, "ROUTE #" + _toDisplayString(_ctx.index + 1), 1),
      _createVNode(_unref(VSelect), {
        modelValue: inputValue.value.route,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue.value.route) = $event)),
        ref_key: "routeRef",
        ref: routeRef,
        hasError: _unref(v$).route.$error,
        placeholder: "Select route",
        options: availableRoutes.value,
        onSelect: onRouteSelect,
        clearable: false,
        class: "route-select"
      }, null, 8, ["modelValue", "hasError", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("label", null, "Dates", -1)),
      _createVNode(_unref(VBtn), {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showDates.value = !showDates.value)),
        class: _normalizeClass(["dropdown-btn", { hasError: _unref(v$).date.$error }]),
        color: "ghost",
        type: "button"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(datesPlaceholder.value), 1),
          _createVNode(SvgIcon, {
            class: _normalizeClass(["icon", { open: showDates.value }]),
            icon: "carbon/chevron-down"
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class"]),
      (showDates.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "dropdownDate",
            ref: dropdownDate,
            class: "date-pickers dates-dropdown"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(VDatePicker), {
                isInline: "",
                hasError: _unref(v$).date.$error,
                ref: "startDateRef",
                class: "date-picker",
                modelValue: inputValue.value.date,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue.value.date) = $event)),
                "min-date": new Date(),
                "max-date": availableDates.value?.endDate,
                disabledDates: availableDates.value?.disabledDates,
                disable: !inputValue.value.route.length,
                weekdaysFormat: "W",
                "initial-page": initialPage.value
              }, null, 8, ["hasError", "modelValue", "min-date", "max-date", "disabledDates", "disable", "initial-page"])
            ])
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})